var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.editMode
    ? _c(
        "div",
        {
          staticClass: "innerPadding30 margin30Top description",
          staticStyle: { "padding-bottom": "20px", border: "1px solid #000" }
        },
        [
          _c("div", { staticClass: "oldTableContainer width100 fontRoboto" }, [
            _vm._v(
              "\n            User Content Administration...\n            "
            ),
            _c("hr"),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "textAlignRight buttonBlockContainerRight" },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-white teaserButton",
                    on: { click: _vm.enterEditMode }
                  },
                  [_vm._v("Weiter")]
                )
              ]
            )
          ])
        ]
      )
    : _c(
        "div",
        {
          staticClass: "border-color-editor",
          staticStyle: { "margin-top": "30px", "padding-bottom": "20px" }
        },
        [
          _c(
            "div",
            {
              staticClass: "oldInnerWrapper tabContent",
              attrs: { id: "berichte1" }
            },
            [
              _c("form", [
                _vm._v(
                  "\n                User Content Administration...\n                "
                ),
                _c("hr"),
                _vm._v(" "),
                _c("div", { staticStyle: { "margin-top": "5px" } }, [
                  _c("div", { staticClass: "radioCheckContainer" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.report.enabled,
                          expression: "model.report.enabled"
                        }
                      ],
                      attrs: {
                        type: "checkbox",
                        id: "enable_reports",
                        name: "enable_reports"
                      },
                      domProps: {
                        checked: Array.isArray(_vm.model.report.enabled)
                          ? _vm._i(_vm.model.report.enabled, null) > -1
                          : _vm.model.report.enabled
                      },
                      on: {
                        __c: function($event) {
                          var $$a = _vm.model.report.enabled,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$c) {
                              $$i < 0 &&
                                (_vm.model.report.enabled = $$a.concat($$v))
                            } else {
                              $$i > -1 &&
                                (_vm.model.report.enabled = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.model.report.enabled = $$c
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "clearfix",
                        attrs: { for: "enable_reports" }
                      },
                      [_vm._v("Berichte unterstützen")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm.model.report.enabled
                  ? _c("div", [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.model.report.visibility,
                              expression: "model.report.visibility"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          class: { error: _vm.errors.has("report_visibility") },
                          staticStyle: { "margin-top": "20px" },
                          attrs: { name: "report_visibility" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.model.report.visibility = $event.target
                                .multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("Sichtbarkeit auswählen")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "PROJECT" } }, [
                            _vm._v("Für Projektteilnehmer einsehbar")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "HIDDEN" } }, [
                            _vm._v("Nur von der Redaktion einsehbar")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.model.report.privilege,
                              expression: "model.report.privilege"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          class: { error: _vm.errors.has("report_privilege") },
                          staticStyle: { "margin-top": "20px" },
                          attrs: { name: "report_privilege" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.model.report.privilege = $event.target
                                .multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("Editierbarkeit auswählen")
                          ]),
                          _vm._v(" "),
                          _c(
                            "option",
                            { attrs: { value: "PROJECT_PARTICIPANT" } },
                            [
                              _vm._v(
                                "Nur Projektteilnehmer können Inhalte einstellen"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "EDITOR" } }, [
                            _vm._v("Nur die Redaktion kann Inhalte einstellen")
                          ])
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("div", { staticStyle: { "margin-top": "5px" } }, [
                  _c("div", { staticClass: "radioCheckContainer" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.links.enabled,
                          expression: "model.links.enabled"
                        }
                      ],
                      attrs: {
                        type: "checkbox",
                        id: "enable_links",
                        name: "enable_links"
                      },
                      domProps: {
                        checked: Array.isArray(_vm.model.links.enabled)
                          ? _vm._i(_vm.model.links.enabled, null) > -1
                          : _vm.model.links.enabled
                      },
                      on: {
                        __c: function($event) {
                          var $$a = _vm.model.links.enabled,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$c) {
                              $$i < 0 &&
                                (_vm.model.links.enabled = $$a.concat($$v))
                            } else {
                              $$i > -1 &&
                                (_vm.model.links.enabled = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.model.links.enabled = $$c
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "clearfix",
                        attrs: { for: "enable_links" }
                      },
                      [_vm._v("Links/Videos unterstützen")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm.model.links.enabled
                  ? _c("div", [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.model.links.visibility,
                              expression: "model.links.visibility"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          class: { error: _vm.errors.has("links_visibility") },
                          staticStyle: { "margin-top": "20px" },
                          attrs: { name: "links_visibility" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.model.links.visibility = $event.target
                                .multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("Sichtbarkeit auswählen")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "PUBLIC" } }, [
                            _vm._v("Öffentlich einsehbar")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "PROJECT" } }, [
                            _vm._v("Für Projektteilnehmer einsehbar")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "HIDDEN" } }, [
                            _vm._v("Nur von der Redaktion einsehbar")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.model.links.privilege,
                              expression: "model.links.privilege"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          class: { error: _vm.errors.has("links_privilege") },
                          staticStyle: { "margin-top": "20px" },
                          attrs: { name: "links_privilege" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.model.links.privilege = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("Editierbarkeit auswählen")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "EVERYONE" } }, [
                            _vm._v("Jeder kann Inhalte einstellen")
                          ]),
                          _vm._v(" "),
                          _c(
                            "option",
                            { attrs: { value: "PROJECT_PARTICIPANT" } },
                            [
                              _vm._v(
                                "Nur Projektteilnehmer können Inhalte einstellen"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "EDITOR" } }, [
                            _vm._v("Nur die Redaktion kann Inhalte einstellen")
                          ])
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("div", { staticStyle: { "margin-top": "5px" } }, [
                  _c("div", { staticClass: "radioCheckContainer" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.images.enabled,
                          expression: "model.images.enabled"
                        }
                      ],
                      attrs: {
                        type: "checkbox",
                        id: "enable_images",
                        name: "enable_images"
                      },
                      domProps: {
                        checked: Array.isArray(_vm.model.images.enabled)
                          ? _vm._i(_vm.model.images.enabled, null) > -1
                          : _vm.model.images.enabled
                      },
                      on: {
                        __c: function($event) {
                          var $$a = _vm.model.images.enabled,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$c) {
                              $$i < 0 &&
                                (_vm.model.images.enabled = $$a.concat($$v))
                            } else {
                              $$i > -1 &&
                                (_vm.model.images.enabled = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.model.images.enabled = $$c
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "clearfix",
                        attrs: { for: "enable_images" }
                      },
                      [_vm._v("Bilder unterstützen")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm.model.images.enabled
                  ? _c("div", [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.model.images.visibility,
                              expression: "model.images.visibility"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          class: { error: _vm.errors.has("images_visibility") },
                          staticStyle: { "margin-top": "20px" },
                          attrs: { name: "images_visibility" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.model.images.visibility = $event.target
                                .multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("Sichtbarkeit auswählen")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "PUBLIC" } }, [
                            _vm._v("Öffentlich einsehbar")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "PROJECT" } }, [
                            _vm._v("Für Projektteilnehmer einsehbar")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "HIDDEN" } }, [
                            _vm._v("Nur von der Redaktion einsehbar")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.model.images.privilege,
                              expression: "model.images.privilege"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          class: { error: _vm.errors.has("images_privilege") },
                          staticStyle: { "margin-top": "20px" },
                          attrs: { name: "images_privilege" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.model.images.privilege = $event.target
                                .multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("Editierbarkeit auswählen")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "EVERYONE" } }, [
                            _vm._v("Jeder kann Inhalte einstellen")
                          ]),
                          _vm._v(" "),
                          _c(
                            "option",
                            { attrs: { value: "PROJECT_PARTICIPANT" } },
                            [
                              _vm._v(
                                "Nur Projektteilnehmer können Inhalte einstellen"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "EDITOR" } }, [
                            _vm._v("Nur die Redaktion kann Inhalte einstellen")
                          ])
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("div", { staticStyle: { "margin-top": "5px" } }, [
                  _c("div", { staticClass: "radioCheckContainer" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.receipe.enabled,
                          expression: "model.receipe.enabled"
                        }
                      ],
                      attrs: {
                        type: "checkbox",
                        id: "enable_receipe",
                        name: "enable_receipe"
                      },
                      domProps: {
                        checked: Array.isArray(_vm.model.receipe.enabled)
                          ? _vm._i(_vm.model.receipe.enabled, null) > -1
                          : _vm.model.receipe.enabled
                      },
                      on: {
                        __c: function($event) {
                          var $$a = _vm.model.receipe.enabled,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$c) {
                              $$i < 0 &&
                                (_vm.model.receipe.enabled = $$a.concat($$v))
                            } else {
                              $$i > -1 &&
                                (_vm.model.receipe.enabled = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.model.receipe.enabled = $$c
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "clearfix",
                        attrs: { for: "enable_receipe" }
                      },
                      [_vm._v("Rezepte unterstützen")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm.model.receipe.enabled
                  ? _c("div", [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.model.receipe.visibility,
                              expression: "model.receipe.visibility"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          class: {
                            error: _vm.errors.has("receipe_visibility")
                          },
                          staticStyle: { "margin-top": "20px" },
                          attrs: { name: "receipe_visibility" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.model.receipe.visibility = $event.target
                                .multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("Sichtbarkeit auswählen")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "PUBLIC" } }, [
                            _vm._v("Öffentlich einsehbar")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "PROJECT" } }, [
                            _vm._v("Für Projektteilnehmer einsehbar")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "HIDDEN" } }, [
                            _vm._v("Nur von der Redaktion einsehbar")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.model.receipe.privilege,
                              expression: "model.receipe.privilege"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          class: { error: _vm.errors.has("receipe_privilege") },
                          staticStyle: { "margin-top": "20px" },
                          attrs: { name: "receipe_privilege" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.model.receipe.privilege = $event.target
                                .multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("Editierbarkeit auswählen")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "EVERYONE" } }, [
                            _vm._v("Jeder kann Inhalte einstellen")
                          ]),
                          _vm._v(" "),
                          _c(
                            "option",
                            { attrs: { value: "PROJECT_PARTICIPANT" } },
                            [
                              _vm._v(
                                "Nur Projektteilnehmer können Inhalte einstellen"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "EDITOR" } }, [
                            _vm._v("Nur die Redaktion kann Inhalte einstellen")
                          ])
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("div", { staticStyle: { "margin-top": "5px" } }, [
                  _c("div", { staticClass: "radioCheckContainer" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.reply.enabled,
                          expression: "model.reply.enabled"
                        }
                      ],
                      attrs: {
                        type: "checkbox",
                        id: "enable_replies",
                        name: "enable_replies"
                      },
                      domProps: {
                        checked: Array.isArray(_vm.model.reply.enabled)
                          ? _vm._i(_vm.model.reply.enabled, null) > -1
                          : _vm.model.reply.enabled
                      },
                      on: {
                        __c: function($event) {
                          var $$a = _vm.model.reply.enabled,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$c) {
                              $$i < 0 &&
                                (_vm.model.reply.enabled = $$a.concat($$v))
                            } else {
                              $$i > -1 &&
                                (_vm.model.reply.enabled = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.model.reply.enabled = $$c
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "clearfix",
                        attrs: { for: "enable_replies" }
                      },
                      [_vm._v("Antworten unterstützen")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm.model.reply.enabled
                  ? _c("div", [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.model.reply.visibility,
                              expression: "model.reply.visibility"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          class: { error: _vm.errors.has("reply_visibility") },
                          staticStyle: { "margin-top": "20px" },
                          attrs: { name: "reply_visibility" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.model.reply.visibility = $event.target
                                .multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("Sichtbarkeit auswählen")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "PUBLIC" } }, [
                            _vm._v("Öffentlich einsehbar")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "PROJECT" } }, [
                            _vm._v("Für Projektteilnehmer einsehbar")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "HIDDEN" } }, [
                            _vm._v("Nur von der Redaktion einsehbar")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.model.reply.privilege,
                              expression: "model.reply.privilege"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          class: { error: _vm.errors.has("reply_privilege") },
                          staticStyle: { "margin-top": "20px" },
                          attrs: { name: "reply_privilege" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.model.reply.privilege = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("Editierbarkeit auswählen")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "EVERYONE" } }, [
                            _vm._v("Jeder kann Inhalte einstellen")
                          ]),
                          _vm._v(" "),
                          _c(
                            "option",
                            { attrs: { value: "PROJECT_PARTICIPANT" } },
                            [
                              _vm._v(
                                "Nur Projektteilnehmer können Inhalte einstellen"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "EDITOR" } }, [
                            _vm._v("Nur die Redaktion kann Inhalte einstellen")
                          ])
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("div", [
                  _c("div", [
                    _c("label", [_vm._v("SEO Title")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.seoTitle,
                          expression: "model.seoTitle"
                        }
                      ],
                      attrs: { type: "text" },
                      domProps: { value: _vm.model.seoTitle },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.model.seoTitle = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("label", [_vm._v("SEO Description")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.seoDescription,
                          expression: "model.seoDescription"
                        }
                      ],
                      attrs: { type: "text" },
                      domProps: { value: _vm.model.seoDescription },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.model.seoDescription = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("label", [_vm._v("SEO Keywords")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.seoKeywords,
                          expression: "model.seoKeywords"
                        }
                      ],
                      attrs: { type: "text" },
                      domProps: { value: _vm.model.seoKeywords },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.model.seoKeywords = $event.target.value
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "textAlignRight buttonBlockContainerRight" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-white teaserButton width50",
                        attrs: { type: "button" },
                        on: { click: _vm.leaveEditMode }
                      },
                      [_vm._v("Abbrechen")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-white teaserButton width50",
                        attrs: { type: "button" },
                        on: { click: _vm.save }
                      },
                      [_vm._v("Absenden")]
                    )
                  ]
                )
              ])
            ]
          )
        ]
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-06ad0407", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06ad0407","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserContentAdministration.vue
// module id = 486
// module chunks = 2